// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isAdminGetImpersonationLogsResult = objectOf({
  recent_impersonation_logs: arrayOf(
    objectOf({
      company_name: string,
      company_id: string,
      type: string,
      expires_at: string,
      is_expired: boolean,
      status: string,
      admins: string,
    })
  ),
});
